/**
 * Whether the details page's read is in flight — the donor's own condition.
 *
 * `ItemDetailsIsland.tsx:120-127` computes this **once**, above the `isPublic`
 * gates, so both audiences get the same answer:
 *
 * ```js
 * const isLoading = isLoadingItem || isFetchingItem;
 * ```
 *
 * It lives here rather than in either route because there are two routes and
 * one donor island: the authed page and the anonymous product page both stand
 * on it, and a condition spelled out twice is a condition that drifts once.
 *
 * **`isFetching` is the half worth naming.** `isPending` alone is the first
 * read only, so a page re-reading over a payload it already holds would keep
 * showing the old values where modsy shows skeletons. RTK Query's `isFetching`
 * covers any request in flight and TanStack Query's means the same thing, so
 * the two map directly.
 *
 * Typed structurally so it takes a `UseQueryResult` without importing one —
 * the flags are all it reads.
 */
export function itemDetailIsLoading(query: { isPending: boolean; isFetching: boolean }): boolean {
  return query.isPending || query.isFetching;
}
